import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminProjects from './AdminProjects';

export default withRequiredAdmin(AdminProjects);
